<template>
    <div class="create-teams">
        <div class="teams-wrap">
            <div class="teams">
                <div class="item team" v-for="(team, index) in teams">
                    <div class="inner">
                        <div class="form-group">
                            <label :for="`team-name-${index}`" class="font-weight-bold">Team #{{ index + 1 }} Name</label>
                            <input type="text"
                                   :id="`team-name-${index}`"
                                   class="form-control"
                                   placeholder="Team Name"
                                   @keyup="update()"
                                   v-model="team.name"/>
                            <div class="text-danger small">{{ utils.errors(errors, `team-name-${index}`).join(', ') }}</div>
                        </div>
                        <div class="form-group">
                            <label :for="`team-students-${index}`" class="font-weight-bold">Team #{{ index + 1 }} Students</label>
                            <textarea class="form-control"
                                      :id="`team-students-${index}`"
                                      v-model="team.students"
                                      @keyup="update()"
                                      :placeholder="`Copy paste one student per line. For example:\nKathy P\nJohn T`"></textarea>
                            <div class="text-danger small">{{ utils.errors(errors, `team-students-${index}`).join(', ') }}</div>
                        </div>
                    </div>
                </div>
                <div class="item add-team">
                    <a class="inner" @click.prevent="addTeam()"><span>+</span></a>
                </div>
            </div>

            <div class="container-fluid">
                <div class="text-danger small">{{ utils.errors(errors, 'team').join(', ') }}</div>
            </div>

        </div>

<!--        <div class="intro">-->
<!--            <img class="img-fluid" src="https://via.placeholder.com/360x360" alt="">-->
<!--        </div>-->

    </div>
</template>

<script>
import utils from "@/mixins/utils";

export default {
    name: "CreateTeams",
    props: ['errors', 'value'],
    emits: ['update'],
    mixins: [utils],

    data(){
        return {
            teams: [],
        }
    },

    methods: {

        addTeam(){
            this.teams.push({
                name: '',
                students: '',
            });
            this.update();
        },

        update(){
            this.$emit('update', {teams: this.teams});
        }

    },


    mounted() {

        jQuery('.create-teams').width(jQuery('.create-project-content').width());

        if( !this.teams.length ){
            this.addTeam();
        }

    }

}
</script>

<style lang="scss" scoped>
.create-teams{
    display: flex;
    align-items: center;
}
.intro{
    flex: 0 0 25%;
    width: 25%;
    padding-left: 1rem;

    img{
        width: 100%;
        height: auto;
    }
}
.teams-wrap{
    flex: 0 0 100%;
    overflow: auto;
    margin-top: 2rem;
}
.teams{
    // flex-wrap: wrap;
    display: flex;
    align-items: stretch;
}
.item{
    padding-right: $grid-gutter-width / 2;
    padding-left: $grid-gutter-width / 2;
    padding-bottom: 1rem;
    display: flex;
    align-items: stretch;
    width: 320px;
    flex: 0 0 320px;

    @include media-breakpoint-up(md){
        width: 320px;
        flex: 0 0 320px;
    }

    @include media-breakpoint-up(lg){
        width: 320px;
        flex: 0 0 320px;
    }

    @include media-breakpoint-up(xl){
        width: 320px;
        flex: 0 0 320px;
    }
}

.inner{
    padding: 1rem;
    border-radius: 1rem;
    background: $light;
    box-shadow: rgba(black, 0.1) 0 3px 6px;
    width: 100%;
    flex-grow: 1;
}

.team{
    textarea{
        min-height: 220px;
    }
}

.add-team{

    .inner{
        display: block;
        min-height: 180px;
        position: relative;
        cursor: pointer;
        transition: background-color .3s;

        &:hover{
            background: darken($light, 1%);

            span{
                background-color: $primary;

                &:after{
                    color: $primary;
                }
            }
        }
    }

    span{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 3rem;
        color: white;
        background: rgba($dark, .2);
        width: 5rem;
        height: 5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        transition: background-color .3s;

        &:after{
            content: 'Add another team';
            position: absolute;
            top: 100%;
            margin-top: 1.5rem;
            font-size: 1rem;
            color: lighten($dark, 30%);
            width: 200px;
            text-align: center;
        }
    }
}
</style>
